// extracted by mini-css-extract-plugin
export var dropdownItemContainer = "weapon-selector-module--dropdown-item-container--bdc25";
export var selectorContainer = "weapon-selector-module--selector-container--8b641";
export var selectorDropdownBase = "weapon-selector-module--selector-dropdown-base--e2910";
export var selectorLabel = "weapon-selector-module--selector-label--a2e37";
export var weaponDropdownBase = "weapon-selector-module--weapon-dropdown-base--6a9d2";
export var weaponDropdownBtn = "weapon-selector-module--weapon-dropdown-btn--3ea17";
export var weaponDropdownItem = "weapon-selector-module--weapon-dropdown-item--aedc6";